import script from "./LiveSportsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSportsContainer.vue?vue&type=script&setup=true&lang=js"

import "./LiveSportsContainer.vue?vue&type=style&index=0&id=4235374d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4235374d"]])

export default __exports__